import React, { useEffect } from "react";
import NavbarGuest from "./NavbarGuest";
import Footer from "./Footer";
import PrivacyPolicyText from "./commonTextPages/PrivacyPolicyText.js";
import WrapperContainer from "./utilities/WrapperContainer.js";

export default function PrivacyPolicyHome() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="fullScreenLayout">
        <NavbarGuest />
        <WrapperContainer
          maxwidth="70%"
          title="Privacy Policy"
          content={<PrivacyPolicyText />}
        />
        <div className="flex-grow-1"></div>
        <Footer />
      </div>
    </>
  );
}
